<template>
  <div class="_modals">
    <b-modal
      id="multipleSKU"
      ref="multipleSKUModal"
      centered
      hide-footer
      :title="'Add Multiple SKU'"
      @hidden="resetForm"
    >
      <div class="pdetail__border px-2 py-4">
        <div class="d-flex mb-3">
          <div class="input__model1group col-12">
            <p class="fontstyle__default">Company Name</p>
            <b-form-input
              type="text"
              v-validate="'required'"
              placeholder="E.g: 1-1000"
              v-model="form.companyName"
              name="Company Name"
              disabled
            ></b-form-input>
            <p v-if="errors.has('Company Name')" class="fontstyle__errormsg">
              {{ errors.first('Company Name') }}
            </p>
          </div>
        </div>
        <div class="input__attachblue mb-2 px-3">
          <p class="textdefault">Upload Document</p>
          <b-form-file
            v-validate="'required'"
            v-model="form.fileExcel"
            name="File Excel"
            accept=".xls, .xlsx"
            id="fileExcel"
            ref="fileExcel"
            @change="onFileChangeEdit"
          />
          <div class="d-flex align-items-center justify-content-between">
            <p class="textdefault text-xs">
              Allowed file type : xlsx (max. 5mb)
            </p>
            <a
              href="https://bucket.andalin.com/assets/WarehouseMultipleSKUFormTemplate.xlsx"
              download
              style="color: #1e3354; font-weight: 700;font-size: 10px;text-decoration: underline;cursor: pointer;"
            >
              Download Excel Format File Here
            </a>
          </div>
          <div
            v-if="errors.has('File Excel')"
            class="text-left input-group __input"
          >
            <small class="text-danger">{{ errors.first('File Excel') }}</small>
          </div>
        </div>
        <div
          id="modalUploadDocument"
          style="margin-left: 1rem;margin-right: 1rem;"
        >
          <p class="fontstyle__default">
            Upload Supporting Document (Optional)
          </p>
          <div
            class="input__dragdrop"
            v-if="
              !Boolean(form.fileDocument) && form.fileDocumentUpload.length < 10
            "
            id="errorfile"
          >
            <b-form-file
              v-model="form.fileDocument"
              name="fileDocumentShipment"
              :multiple="true"
              drop-placeholder="Drop file here..."
            >
              <template slot="placeholder">
                <img
                  class="input__dragdrop--img"
                  src="@/assets/image/icon/icon-upload-drag-drop.svg"
                  alt=""
                />
                <p class="mt-3">
                  Drag your file here or
                  <u style="color: #1E3354; font-weight: 700">Choose file</u>
                </p>
                <p style="font-size:10px">
                  Allowed file type : doc, docx, xlsx, pdf (max. 10 MB)
                </p>
              </template>
            </b-form-file>
            <p class="textinfo text-left">{{ errorForm.fileInput }}</p>
          </div>
          <div v-if="!statusForm">
            <div
              class="input__dragdrop text-center p-4"
              style="border: 1px dashed rgb(196, 35, 42);"
            >
              <img
                class="input__dragdrop--img"
                src="@/assets/image/icon/icon-upload-drag-dropred.svg"
                alt=""
              />
              <p
                class="mt-3"
                style="color:rgb(196, 35, 42);font-style: normal;font-weight: normal;font-size:10px"
              >
                {{ messageFileError }} <br />
                <u
                  style="color: #1E3354; font-weight: 700"
                  @click="resetModalUploadDoc()"
                  >Choose file</u
                >
              </p>
            </div>
          </div>
          <div
            v-if="
              !progressBar.status &&
                showProgressText(progressBar.value, progressBar.max) <= 100
            "
            class="mb-4"
          >
            <p class="mb-2 fontstyle__default">Uploading</p>
            <b-progress :max="progressBar.max" show-progress>
              <b-progress-bar
                :value="progressBar.value"
                :label="
                  `${showProgressText(
                    progressBar.value,
                    progressBar.max
                  )}% Uploading...`
                "
              ></b-progress-bar>
            </b-progress>
            <p class="fontstyle__default">
              Uploading your file, please wait...
            </p>
          </div>
          <div v-if="!isLoadingProgress">
            <div
              v-if="
                form.fileDocumentUpload && form.fileDocumentUpload.length > 0
              "
            >
              <div
                class="d-flex justify-content-between align-items-center stylefile p-2 mt-2"
                v-for="(file, index) in form.fileDocumentUpload"
                :key="index"
              >
                <div class="d-flex align-items-center">
                  <img
                    class="mr-2"
                    src="@/assets/image/icon/icon-file.svg"
                    alt=""
                  />
                  <p
                    class="fontstyle__default"
                    style="color: var(--primary-400, #1D3354);"
                  >
                    <b style="word-break: break-all;">{{
                      file ? file.name : ''
                    }}</b>
                  </p>
                </div>
                <div>
                  <img
                    src="@/assets/image/icon/icon-tresh-red.svg"
                    style="cursor: pointer"
                    @click="removeContainer(index, file)"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-2">
        <button
          class="button__bluecorporite"
          :disabled="
            isLoadingMultipleSkuUpload ||
              (!progressBar.status &&
                showProgressText(progressBar.value, progressBar.max) <= 100)
          "
          @click="submit"
          style="border-radius: 4px !important;font-size: 12px !important;"
        >
          <div
            v-if="isLoadingMultipleSkuUpload"
            class="spinner-border"
            role="status"
            style="width: 1rem !important;height: 1rem !important;"
          >
            <span class="sr-only">Loading...</span>
          </div>
          <span v-else>Add Multiple SKU</span>
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MultipleSKUModal',
  props: {
    viewModal: Boolean,
    editData: Object
  },
  computed: {
    ...mapGetters({
      multipleSkuUpload: 'warehouse/multipleSkuUpload',
      isLoadingMultipleSkuUpload: 'warehouse/isLoadingMultipleSkuUpload',
      errorMultipleSkuUpload: 'warehouse/errorMultipleSkuUpload'
    }),
    formFile() {
      return this.form.fileDocument
    }
  },
  data() {
    return {
      statusForm: true,
      isLoadingProgress: true,
      form: {
        id: this.$route.params.id || '',
        companyName: '',
        fileExcel: null,
        fileDocument: null,
        fileDocumentUpload: [],
        fileDelete: []
      },
      progressBar: {
        value: 0,
        max: 0,
        status: false
      },
      message: '',
      messageFileError: '',
      errorForm: {
        fileExcel: '',
        fileInput: ''
      }
    }
  },
  watch: {
    viewModal(value) {
      if (value) {
        this.$refs.multipleSKUModal.show()
        this.form.companyName = JSON.parse(
          localStorage.getItem('profile')
        ).companyName
      }
    },
    formFile(data) {
      if (data && data.length > 0) {
        data.filter(item => {
          this.messageFileError = ''
          if (item.size > 10485760) {
            this.statusForm = false
            this.messageFileError =
              'Sorry, your file is too big. Please upload file with maximum 10 MB.'
            this.progressBar.status = true
            return
          }
          if (
            item.type !== 'application/pdf' &&
            item.type !==
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
            item.type !== 'application/msword' &&
            item.type !==
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          ) {
            this.statusForm = false
            this.messageFileError =
              'Sorry, you are not allowed to upload this file type'
            this.progressBar.status = true
            return
          }
          this.progressBar.max += item.size
          this.form.fileDocumentUpload.push(item)
          if (
            this.form.fileDocumentUpload &&
            this.form.fileDocumentUpload.length > 10
          ) {
            this.form.fileDocumentUpload.filter((data, i) => {
              if (i > 9) {
                this.removeContainer(i)
              }
            })
          }
        })
        if (this.statusForm) {
          this.startTimer()
        }
      }
    }
  },
  methods: {
    onFileChangeEdit(e) {
      const al = this
      const files = e.target.files || e.dataTransfer.files
      if (files[0].size < 5242880) {
        this.message = ''
        for (let index = 0; index < files.length; index++) {
          const reader = new FileReader()
          reader.onload = function(event) {
            const imageUrl = event.target.result
            al.form.pictureName = imageUrl
          }
          reader.readAsDataURL(files[index])
        }
      } else {
        this.form.fileExcel = null
        this.errorForm.fileExcel = 'Your file exceeded maximum requirement file'
      }
    },
    startTimer() {
      let byte = 102400 // 100 kb to byte
      const vm = this.progressBar
      vm.status = false
      this.isLoadingProgress = true
      const timer = setInterval(() => {
        // set kecepatan progress
        if (vm.max > 1048576) {
          // 1MB
          byte = 1048576
        } else if (vm.max < 102400) {
          byte = 10240 // 10KB
        }
        // kalo ada ekor angka yang < byte, langsung nambain ekornya biar progress 100%
        if (vm.value + byte > vm.max) {
          vm.value += vm.max % byte
        } else {
          vm.value += byte
        }
        if (vm.value >= vm.max) {
          clearInterval(timer)
          vm.status = true
          this.isLoadingProgress = false
          this.resetModalUploadDoc()
        }
      }, 1000)
    },
    removeContainer(index, data) {
      this.form.fileDocumentUpload.splice(index, 1)
      if (data && data.id) {
        this.form.fileDelete.push(data.id)
      }
    },
    resetModalUploadDoc() {
      this.form.fileDocument = null
      this.statusForm = true
      this.progressBar = {
        value: 0,
        max: 0,
        status: false
      }
      this.errorForm = {
        fileInput: '',
        fileExcel: ''
      }
    },
    resetForm() {
      this.form = {
        fileExcel: null,
        fileDocument: null,
        fileDelete: [],
        fileDocumentUpload: []
      }
      this.message = ''
      this.resetModalUploadDoc()
      this.$emit('update:viewModal', false)
    },
    showProgressText(start, max) {
      return ((start / max) * 100).toFixed(0)
    },
    submit() {
      if (!this.message) {
        this.$validator.validateAll().then(result => {
          if (result) {
            let formData = new FormData()
            formData.append('fileDocument', this.form.fileExcel)
            this.$store
              .dispatch('warehouse/MULTIPLE_SKU_UPLOAD', formData)
              .then(res => {
                if (!this.errorMultipleSkuUpload) {
                  this.$emit('handle-result', {
                    status: true,
                    data: this.multipleSkuUpload,
                    fileSupportingDocument: this.form.fileDocumentUpload
                  })
                  this.resetModalUploadDoc()
                  this.resetForm()
                  this.$refs.multipleSKUModal.hide()
                } else {
                  this.$emit('handle-result', {
                    status: false,
                    data:
                      this.errorMultipleSkuUpload.data.message ||
                      'Unknown error occured!',
                    fileSupportingDocument: []
                  })
                }
              })
            return
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.pdetail {
  &__header {
    font-size: 16px;
    font-weight: 700;
    color: #1d3354;
    @media only screen and (max-width: 1536px) {
      margin: 1.5rem 0rem 0.5rem 0rem !important;
    }
  }
  &__paragraph1 {
    font-size: 14px;
    font-weight: 400;
    color: #6e6e6e;
  }
  &__paragraph2 {
    font-size: 14px;
    font-weight: 600;
    color: #1d3354;
  }
  &__border {
    border: 1px solid #dadee2;
    border-radius: 8px;
    @media only screen and (min-width: 1536px) {
      padding: 1.5rem;
    }
    padding: 1rem;
    column-gap: 1rem;
  }
  &__buttonwhite {
    width: 185px;
    height: 36px;
    color: #1d3354;
    border: 1px solid #1d3354;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.011em;
  }
  &__buttonred {
    width: 100px;
    height: 36px;
    color: #c4232a;
    border: 1px solid #c4232a;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.011em;
  }
}
.input__attachblue .custom-file-input ~ .custom-file-label[data-browse]::after,
.form-file-text {
  font-size: 12px;
}
#modalUploadDocument .form-file-text {
  margin-top: -45px;
}
#uploadPicture .b-form-file {
  width: 109px;
}
#uploadPicture .custom-file-label {
  padding: 0.4rem 0.25rem 1.4rem 6.25rem !important;
}
.customplaceholder {
  ::placeholder {
    color: #9ea1a4 !important;
  }

  @media only screen and (min-width: 1536px) {
    width: 100%;
  }

  width: 73%;
}
.stylefile {
  border-radius: 4px;
  border: 1px dashed var(--neutral-500, #b6b6b6);
  background: var(--neutral-20, #ecf1f5);
}
</style>



// WEBPACK FOOTER //
// src/components/global/modals/MultipleSKUModal.vue